module.exports = __webpack_public_path__ + "img/phone.2f97d963.png";